/**
 * The officer's action-card DISPLAY caps: how many cards of a kind are visible at
 * once (the rest stay queued). One TS home for them, bound with the Python and SQL
 * copies to test-fixtures/action-display/caps.v1.json by parity tests (Q-481).
 */
export const MAX_VISIBLE_QUESTIONS = 8;
/** Tasks and suggestions together, in the canonical projection (lib/callActions.ts). */
export const MAX_VISIBLE_NON_QUESTIONS = 4;
/**
 * Tasks and suggestions share the non-question slots. Suggestions are generated
 * far more aggressively and are reordered every prioritization cycle, so without
 * a reservation they monopolize all non-question slots and active tasks sit in
 * the queue forever ("we have no tasks" symptom). Reserve up to this many of the
 * non-question slots for tasks whenever active tasks exist; suggestions may use
 * unreserved slots and any slots tasks don't fill.
 */
export const MIN_VISIBLE_TASK_SLOTS = 2;
